import styled from 'styled-components/macro'
import {
  ModalContent,
  Stack,
  Text
} from '@chakra-ui/react'
import { motion } from 'framer-motion'
import { COLORS } from 'utils/styles'

const MotionStack = motion(Stack)
const MotionModalContent = motion(ModalContent)

export const ModalContentStyled = styled(MotionModalContent)`
  width: 400px !important;
  padding: 0 !important;
  background: linear-gradient(to bottom, lightgray, gray) !important;
  border: 1px solid black;

  @media (max-width: 1000px) and (max-height: 600px) {
    width: 95.5% !important;
  }

  @media (max-width: 600px) and  (max-height: 1000px) {
    width: 95.5% !important;
  }
`

export const BtnStack = styled(Stack)`
  width: 60%;
  height: 35px;
`

export const BtnStyled = styled(MotionStack)`
  font-size: 20px;
  font-weight: 100;
  height: 40px;
  border-radius: 10px;
  background: ${COLORS.gold};
  border: 1px solid black;
  cursor: pointer;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  user-select: none;

  &:hover {
    background: ${COLORS.gold_hover};
  }
`

export const TextBody = styled(Text)`
  font-size: 15px;
  font-weight: 700;
  text-shadow: 0 0 2px yellow;
`

export const TextHeader = styled(Text)`
  font-size: 25px;
  font-weight: 700;
  text-shadow: 0 0 3px yellow;
`

export const TextHeader2 = styled(Text)`
  font-size: 22px;
  font-weight: 700;
  text-shadow: 0 0 3px yellow;
`

export const TextStack = styled(Stack)`
  margin: 10px 0;
  gap: 0 !important;
`
